import { ButtonType, ButtonVariant } from "@/componentsDS/Button/Button.type";
import Button from "@/componentsDS/Button/Button";
import Modal from "@/dsComponents/Modal";
import { ModalBody, ModalFooter, ModalFooterLeft, ModalFooterRight, ModalHeader, ModalTitle } from "@dextech-ai/dex-design-system";
import { InfoOutlined } from "@dextech-ai/dex-design-system/icons";
import PropTypes from "prop-types";

export const DeleteModelTerm = ({
	isModalVisible,
	hideModal,
	onDeleteHandler,
	termClauseCount
}) => {
	return (
		<Modal visible={isModalVisible} close={hideModal}>
			<ModalHeader icon={<InfoOutlined data-ds-color="primary-dark" />}>
				<ModalTitle>Delete Template</ModalTitle>
			</ModalHeader>
			<ModalBody>
				<div className="action-modal__text">
					Delete eBL Template? {termClauseCount === 1 ? ' Issuance will be disabled if there is no Model Terms for ETR.' : ' This action is irreversible.'}
				</div>
			</ModalBody>
			<ModalFooter>
				<ModalFooterLeft>
					<Button
						onClick={hideModal}
						text="Cancel"
						type={ButtonType.GHOST}
						variant={ButtonVariant.DESTRUCTIVE}
					/>
				</ModalFooterLeft>
				<ModalFooterRight>
					<Button
						onClick={onDeleteHandler}
						text="Confirm"
						type={ButtonType.SOLID}
						variant={ButtonVariant.DESTRUCTIVE}
						className="account-settings__modal_term-action"
					/>
				</ModalFooterRight>
			</ModalFooter>
		</Modal>
	);
};

DeleteModelTerm.propTypes = {
	isModalVisible: PropTypes.bool.isRequired,
	hideModal: PropTypes.func.isRequired,
	onDeleteHandler: PropTypes.func.isRequired,
	termClauseCount: PropTypes.number
};
